import React, { useContext } from 'react'

import JsonLd from '@/components/shared/jsonld'
import productionDetailsContext from '@/context/production-details'

const LdJsonProduction: React.FC = () => {
    const {
        selectors: { jsonLdData },
    } = useContext(productionDetailsContext)
    return <JsonLd items={[jsonLdData]} />
}

export default LdJsonProduction
